export class SingleTableModel {

  constructor(
    public id: string,
    public transactionId: string,
    public email: string,
    public flow_id: string,
    public isActive: boolean,
    public recordType: string,
    public accessKey: string,
    public name: string,
    public transactionJSON: string,
    public tsn: string,
    public updateDate: string,
    public updateEpochTime: number,
    public apiKey: string,
    public accessAssociation: string,
    public clientType: string,
    public updateBy: string,
    public accessAssociationIds: string,
  ) { }

}

export class LastEvaluatedKey {
  constructor(
    public tenantId: string,
    public tenantAccessKey: string
  ) { }
}

export class AccessAssociation {
  constructor(
    public name: string,
    public value: string,
    public isAssociated: boolean = false
  ) { }
}
